import { gql } from '@apollo/client';
import IconArrowRight from '@apollo/icons/default/IconArrowRight.svg';
import IconDiff from '@apollo/icons/default/IconDiff.svg';
import React from 'react';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';

import {
  changelogSingleChangeRouteConfig,
  variantRouteConfig,
} from 'src/app/graph/routes';
import { LaunchChangelogResultFragment } from 'src/lib/graphqlTypes/types';

export const launchChangelogResultFragment = gql`
  fragment LaunchChangelogResultFragment on Launch {
    id
    graphId
    graphVariant
    results {
      ... on ChangelogLaunchResult {
        schemaTagID
      }
      __typename
    }
  }
`;

type Props = {
  launch: LaunchChangelogResultFragment;
  showIcon?: boolean;
};

export const ChangelogResult = ({ launch, showIcon }: Props) => {
  const location = useLocation();
  return (
    <>
      {launch.results.map((result) => {
        return (
          <Link
            key={result.schemaTagID}
            to={changelogSingleChangeRouteConfig.locationFrom({
              location,
              fromRouteConfig: variantRouteConfig,
              patch: {
                version: result.schemaTagID,
                graphVariant: launch.graphVariant,
              },
            })}
            className="group"
          >
            <div className="flex items-center justify-between rounded px-2 py-1 hover:bg-secondary">
              <div className="flex items-center overflow-hidden">
                {showIcon && <IconDiff className="mr-2 text-icon-primary" />}
                <div className="truncate text-sm text-neutral">
                  {launch.graphVariant}
                </div>
              </div>
              <IconArrowRight className="text-icon-primary opacity-0 group-hover:opacity-100" />
            </div>
          </Link>
        );
      })}
    </>
  );
};
